import { useContext } from 'react';
import { EarningsContext } from 'context/EarningsContext';

export const useEarnings = () => {
  const response = useContext(EarningsContext);
  if (!response) {
    throw new Error('useEarnings must be used within EarningsProvider');
  }
  return response;
};
